import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';


/*
  Standalone use of the loading spinner:

  import LoadingSpinner from 'contexts/loading-spinner/loading-spinner';
  const [showLoading, setShowLoading] = useState(false);
  setShowLoading(true);
  onError: ()=>setShowLoading(false)

  {showLoading && (
    <LoadingSpinner text='Procesando cambio...' bgOpacity={0.5}/>
  )}
*/




const Loading = ({ subtitle, bgOpacity = 0}) => 
{
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `rgba(0,0,0,`+bgOpacity+`)`,
        zIndex: 3000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
        <Box  sx={{ p:2, margin:'auto', textAlign:'center' }} >
          <CircularProgress/>
        </Box>
        {subtitle && (
          <Typography variant="body2" sx={{fontWeight:300, color:"common.white", whiteSpace: 'pre-wrap', textAlign: 'center' }}>
            {subtitle}
          </Typography>
        )}
    </Box>
  );
};

export default Loading;
